import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Modal from '../../../client/components/Modal';

const SELECTOR_WRAPPER = '.p-course-booking-confirmation';
const SELECTOR_MODAL = '#js-course-booking-confirmation-modal';
const SELECTOR_CANCEL_BUTTON = '.p-course-booking-confirmation__cancel-booking-btn';
const SELECTOR_MODAL_CANCEL_BUTTON = '.p-course-booking-confirmation__modal-cancel-btn';
const SELECTOR_MODAL_ACTION_BUTTON = '.p-course-booking-confirmation__modal-action-btn';

const SELECTOR_MULTIPLE_SESSION_WRAPPER = '.p-course-booking-confirmation__sessions';
const SELECTOR_SELECT_ALL_WRAPPER = '.p-course-booking-confirmation__session-selectall';
const SELCTOR_SESSONS_WRAPPER = '.p-course-booking-confirmation__session-list';
const SELECTOR_CANCEL_BOOKING_FORM = '.p-course-booking-confirmation__session-book-form';

const SELECTOR_SNACKBAR = '.lta-snackbar';
const SELECTOR_ALERT = '.js-alert-dismiss';

const CLICK_EVENT = 'click';

class CourseBookingConfirmation {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.confirmationModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.confirmationModal = new Modal(this.confirmationModalElement, { backdrop: 'static' });
		this.cancelBookingButton = SelectorEngine.findOne(SELECTOR_CANCEL_BUTTON, this._wrapper);

		this.alertWrapper = SelectorEngine.findOne(SELECTOR_SNACKBAR, this._wrapper);
		if(this.alertWrapper) {
			this.dismissAlert = SelectorEngine.findOne(SELECTOR_ALERT, this.alertWrapper);
			EventHandler.on(this.dismissAlert, CLICK_EVENT, this.dismissAlertClickHandler.bind(this));
		}

		this.modalCancelButton = SelectorEngine.findOne(SELECTOR_MODAL_CANCEL_BUTTON, this.confirmationModalElement);
		this.multipleSessionWrapper = SelectorEngine.findOne(SELECTOR_MULTIPLE_SESSION_WRAPPER, this.confirmationModalElement);
		if(this.multipleSessionWrapper) {
			this.modalActionButton = SelectorEngine.findOne(SELECTOR_MODAL_ACTION_BUTTON, this.confirmationModalElement);
			this.selectAllWrapper = SelectorEngine.findOne(SELECTOR_SELECT_ALL_WRAPPER, this.multipleSessionWrapper);
			if(this.selectAllWrapper) {
				this.selectAllCheckbox = SelectorEngine.findOne('input[type=checkbox]', this.selectAllWrapper);
				EventHandler.on(this.selectAllCheckbox, CLICK_EVENT, this.selectAllClickHandler.bind(this));
			}
			this.sessionsWrapper = SelectorEngine.findOne(SELCTOR_SESSONS_WRAPPER, this.confirmationModalElement);
			this.cancelBookingForm = SelectorEngine.findOne(SELECTOR_CANCEL_BOOKING_FORM, this.confirmationModalElement);
			
			if(this.sessionsWrapper) {
				this.sessionsCards = SelectorEngine.find('.p-course-booking-confirmation__sessiontime', this.sessionsWrapper);
				this.sessionCheckBox = SelectorEngine.find('input[type=checkbox]', this.sessionsWrapper);

				this.sessionsCards.forEach((checkbox) => {
					EventHandler.on(checkbox, CLICK_EVENT, this.sessionCardClickHandler.bind(this));
				});

				this.sessionCheckBox.forEach((checkbox) => {
					EventHandler.on(checkbox, CLICK_EVENT, this.checkBoxClickHandler.bind(this));
				});
			}

			EventHandler.on(this.modalActionButton, CLICK_EVENT, this.cancelBookingClickHandler.bind(this));
		}
		
		EventHandler.on(this.cancelBookingButton, CLICK_EVENT, this.cancelButtonClickHandler.bind(this));
		EventHandler.on(this.modalCancelButton, CLICK_EVENT, () => {
			this.confirmationModal.hide();
		});
	}

	dismissAlertClickHandler() {
		this.alertWrapper.parentElement.classList.add('u-hidden');
	}

	selectAllClickHandler(event) {
		if(event.target.checked) {
			this.multipleSessionWrapper.classList.remove('invalid');
			this.sessionsCards.forEach((sessionCard) => {
				const checkbox = SelectorEngine.findOne('input[type=checkbox]', sessionCard);
				sessionCard.classList.add('selected');
				checkbox.checked = "checked";
			});
		} else {
			this.sessionsCards.forEach((sessionCard) => {
				const checkbox = SelectorEngine.findOne('input[type=checkbox]', sessionCard);
				sessionCard.classList.remove('selected');
				checkbox.checked = false;
			});
		}
	}

	sessionCardClickHandler(event) {
		const cardCheckBox = SelectorEngine.findOne('input[type="checkbox"]', event.currentTarget);
		cardCheckBox.click();
	}

	checkBoxClickHandler(event) {
		const checkBox = event.target;
		if(checkBox.checked) {
			this.multipleSessionWrapper.classList.remove('invalid');
			checkBox.parentElement.classList.add('selected');
		} else {
			checkBox.parentElement.classList.remove('selected');
		}
		this.selectAllCheckbox.checked = this.isSelectAllChecked() ? "checked" : false;
		event.stopPropagation();
	}

	isSelectAllChecked() {
		const checkBoxes = this.sessionCheckBox.filter((checkbox) => !checkbox.checked);
		return checkBoxes.length > 0 ? false : true;
	}

	cancelButtonClickHandler() {
		this.confirmationModal.show();
	}

	cancelBookingClickHandler() {
		const isCheckBoxSelected = this.sessionCheckBox.filter((checkbox) => checkbox.checked);
		if(isCheckBoxSelected.length > 0){
			this.multipleSessionWrapper.classList.remove('invalid');
			this.cancelBookingForm.submit();
		} else {
			this.multipleSessionWrapper.classList.add('invalid');
		}
	}
}

const globalCourseBookingConfirmation = new CourseBookingConfirmation();
export default globalCourseBookingConfirmation;
